<div class="modal-header">
    <button (click)="close()"
            (keydown.enter)="close()"
            aria-label="Close"
            class="close"
            data-dismiss="modal"
            type="button">
        <span class="svg-icon svg-close-primary"></span>
    </button>
</div>
<div class="modal-body notif-styles">
    <div class="notif-styles__content">
        <div class="notif-styles__content-title">
            {{properties.notificationModal.promotionExpired}}
        </div>
        <div class="notif-styles__content-subtitle body-text">
            {{properties.notificationModal.weAreSorry}} {{campaignTitle ? campaignTitle : "offer"}} {{properties.notificationModal.noLongerAvailable}}
        </div>
        <div>
            <button (click)="close()"
                    (keydown.enter)="close()"
                    aria-label="View current offers"
                    class="btn btn-large btn-primary"
                    data-dismiss="modal">
                {{properties.notificationModal.viewOffers}}
            </button>
        </div>
    </div>
</div>
